import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './BottomNav.css';

/**
 * Deneme: mobil tarzı alt gezinme çubuğu.
 * Kapatmak için BOTTOM_NAV_ENABLED = false yapmak yeterli (ya da bu commit'i geri almak).
 */
export const BOTTOM_NAV_ENABLED = true;

// Çubuğun görüneceği sayfalar.
const NAV_PATHS = [
  '/game', '/battle', '/village', '/inventory', '/achievements', '/arena', '/work', '/fishing',
  '/mining', '/farming', '/craft', '/market', '/wiki', '/versions', '/dungeon', '/profile',
];

const MAIN_TABS = [
  { key: 'home', route: '/game', icon: '/image/menu/ana-menu.png', fallback: '🏠', labelKey: 'navHome', match: ['/game'] },
  { key: 'battle', route: '/battle', icon: '/image/menu/savas.png', fallback: '⚔️', labelKey: 'menuBattle', match: ['/battle'] },
  { key: 'inventory', route: '/inventory', icon: '/image/menu/envanter.png', fallback: '🎒', labelKey: 'menuInventory', match: ['/inventory'] },
  { key: 'village', route: '/village', icon: '/image/menu/koy.png', fallback: '🏘️', labelKey: 'menuVillage', match: ['/village', '/work', '/fishing', '/mining', '/farming', '/craft'] },
];

const MORE_ITEMS = [
  { key: 'profile', route: '/profile', icon: '/image/menu/profil.png', fallback: '👤', labelKey: 'menuProfile' },
  { key: 'dungeon', route: '/dungeon', icon: '/image/menu/zindan.png', fallback: '🏰', labelKey: 'menuDungeon' },
  { key: 'arena', route: '/arena', icon: '/image/menu/arena.png', fallback: '🏟️', labelKey: 'menuArena' },
  { key: 'achievements', route: '/achievements', icon: '/image/menu/basarilar.png', fallback: '🏆', labelKey: 'menuAchievements' },
  { key: 'market', route: '/market', icon: '/image/menu/pazar.png', fallback: '🛒', labelKey: 'menuMarket' },
  { key: 'work', route: '/work', icon: '/image/menu/calisma.png', fallback: '🛠️', labelKey: 'menuWork' },
  { key: 'wiki', route: '/wiki', icon: '/image/menu/wiki.png', fallback: '📖', labelKey: 'menuWiki' },
];
const MORE_PATHS = MORE_ITEMS.map((i) => i.route).filter((r) => r !== '/work');

function NavIcon({ src, fallback }) {
  const [broken, setBroken] = useState(false);
  if (broken || !src) return <span className="bottom-nav__emoji" aria-hidden="true">{fallback}</span>;
  return <img className="bottom-nav__img" src={src} alt="" draggable={false} onError={() => setBroken(true)} />;
}

export default function BottomNav() {
  const { t } = useTranslation('selection');
  const location = useLocation();
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);
  const sheetRef = useRef(null);
  const path = location.pathname;
  const visible = BOTTOM_NAV_ENABLED && NAV_PATHS.includes(path) && Boolean(localStorage.getItem('username'));

  useEffect(() => {
    if (!visible) return undefined;
    document.body.classList.add('has-bottom-nav');
    return () => document.body.classList.remove('has-bottom-nav');
  }, [visible]);

  useEffect(() => { setMoreOpen(false); }, [path]);

  useEffect(() => {
    if (!moreOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setMoreOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [moreOpen]);

  if (!visible) return null;

  const go = (route) => {
    setMoreOpen(false);
    if (route !== path) navigate(route);
  };
  const moreActive = MORE_PATHS.includes(path);

  return (
    <>
      {moreOpen && (
        <div className="bottom-nav-sheet-overlay" onClick={() => setMoreOpen(false)}>
          <div
            className="bottom-nav-sheet"
            ref={sheetRef}
            role="menu"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bottom-nav-sheet__handle" aria-hidden="true" />
            <div className="bottom-nav-sheet__grid">
              {MORE_ITEMS.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  role="menuitem"
                  className={`bottom-nav-sheet__item${path === item.route ? ' is-active' : ''}`}
                  onClick={() => go(item.route)}
                >
                  <NavIcon src={item.icon} fallback={item.fallback} />
                  <span>{t(item.labelKey)}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      <nav className="bottom-nav" aria-label={t('navLabel')}>
        {MAIN_TABS.map((tab) => {
          const active = tab.match.includes(path);
          return (
            <button
              key={tab.key}
              type="button"
              className={`bottom-nav__tab${active ? ' is-active' : ''}`}
              aria-current={active ? 'page' : undefined}
              onClick={() => go(tab.route)}
            >
              <NavIcon src={tab.icon} fallback={tab.fallback} />
              <span className="bottom-nav__label">{t(tab.labelKey)}</span>
            </button>
          );
        })}
        <button
          type="button"
          className={`bottom-nav__tab${moreActive || moreOpen ? ' is-active' : ''}`}
          aria-haspopup="menu"
          aria-expanded={moreOpen}
          onClick={() => setMoreOpen((v) => !v)}
        >
          <span className="bottom-nav__emoji bottom-nav__more" aria-hidden="true">☰</span>
          <span className="bottom-nav__label">{t('navMore')}</span>
        </button>
      </nav>
    </>
  );
}
